import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL } from "../../../Config/Config";
import "../QuestionDashboard/questiondashborad.css";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
// import "./reviewer.css";
import "./hodboard.css";
const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  dataClient,
  setPagePath,
  renderQuestionText,
  selectedRows,
  setSelectedRows,
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");

  const [appliedFilters, setAppliedFilters] = useState({});

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });
  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);
  const columnDropdownRef = useRef(null);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);
  const [filters, setFilters] = useState({}); // Holds current selections
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isFilterDropdownSelected, setIsFilterDropdownSelected] =
    useState(false);

  // useEffect(() => {
  //   if (headers.length > 0) {
  //     // Find "Question ID" and keep it at the start, then add the next 4 columns (excluding "Question ID" if repeated)
  //     const questionIdHeader = headers.find((h) => h === "Question ID");
  //     const rest = headers.filter((h) => h !== "Question ID");
  //     setVisibleColumns([questionIdHeader, ...rest.slice(0, 4)]);
  //   }
  // }, [headers]);

  const isAllSelected =
    Object.keys(appliedFilters).length > 0
      ? paginatedData.every((row) => selectedRows.includes(row[0]))
      : selectedRows.length === data.length;

  useEffect(() => {
    if (headers.length > 0) {
      // Always show "Question ID" (index 0) and "Question Text" (index 1) first, then next 3 columns (excluding "Set ID")
      const questionIdHeader = headers[0];
      const questionTextHeader = headers[1];
      const rest = headers.filter(
        (header, idx) => header !== "Set ID" && idx > 1
      );
      setVisibleColumns([
        questionIdHeader,
        questionTextHeader,
        ...rest.slice(0, 3),
      ]);
    }
  }, [headers]);

  const handleColumnSelection = (column) => {
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const handleFilterSelection = (selectedOption, header) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [header]: selectedOption,
    }));

    setIsFilterDropdownSelected(true); // Mark dropdown as interacted
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");

    if (!fileName) {
      return;
    }

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([
        visibleColumns,
        ...exportData,
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });

      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      if (Object.keys(appliedFilters).length > 0) {
        // If filters are applied, select only filtered data
        const filteredIds = paginatedData.map((row) => row[0]);
        setSelectedRows((prevSelected) => {
          // Combine previously selected rows with new filtered selections
          const combined = [...prevSelected, ...filteredIds];
          // Remove duplicates
          return [...new Set(combined)];
        });
      } else {
        // If no filters, select all data
        setSelectedRows(data.map((row) => row[0]));
      }
    } else {
      if (Object.keys(appliedFilters).length > 0) {
        // If filters are applied, deselect only filtered data
        const filteredIds = paginatedData.map((row) => row[0]);
        setSelectedRows((prevSelected) =>
          prevSelected.filter((id) => !filteredIds.includes(id))
        );
      } else {
        // If no filters, deselect all
        setSelectedRows([]);
      }
    }
  };

  const handleRowSelect = (rowIndex) => {
    // Calculate the actual index based on current page and page size
    const actualIndex = (currentPage - 1) * pageSize + rowIndex;
    const questionId = sortedData[actualIndex][0]; // Get question ID from sorted data

    setSelectedRows((prev) =>
      prev.includes(questionId)
        ? prev.filter((id) => id !== questionId)
        : [...prev, questionId]
    );
  };

  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      ); // Min width: 100px
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          // className="col-tc"
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {headers
                  .filter(
                    (header) => header !== "Set ID" && header !== "Status"
                  )
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                        disabled={column === "Question ID"}
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative", // Ensure position for pseudo-element
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                        }}
                      >
                        {index === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                            style={{ width: "10px", height: "10px" }}
                          />
                        )}
                        {heading}
                        {index === 1 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          width: cellIndex === 1 ? `${columnWidth}px` : "auto",
                          textAlign: "left",
                          color: "#6A6A6A",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: `${columnWidth}px`,
                        }}
                      >
                        {cellIndex === 0 ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="checkbox"
                              className="delete-question-checkbox-dqc"
                              checked={selectedRows.includes(row[0])}
                              onChange={() => handleRowSelect(rowIndex)}
                              style={{ marginRight: "8px" }}
                            />
                            <Link
                              style={{ color: "#337ab7" }}
                              to={`/hod_review?MNTQuestionNumbers=${row[0]}`}
                            >
                              <span
                                className="truncated-text"
                                title={row[headers.indexOf(column)]}
                              >
                                {headers.indexOf(column) === 2
                                  ? renderQuestionText(
                                      row[headers.indexOf(column)]
                                    ) // Render LaTeX here
                                  : row[headers.indexOf(column)]}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          <span className="truncated-text-2">
                            {headers.indexOf(column) === 2
                              ? renderQuestionText(row[headers.indexOf(column)]) // Render LaTeX for LaTeX column
                              : row[headers.indexOf(column)]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn-HOD"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              {/* Show the Reset button only after Apply is clicked */}

              {/* Always show the Apply button */}
              <button
                // className="apply-btn-question-review-dash"
                className="create-test-section-btn"
                onClick={handleApplyFilter}
              >
                APPLY
              </button>
              {isFiltersApplied && (
                <button
                  className="create-test-section-btn"
                  onClick={handleResetFilter}
                >
                  RESET
                </button>
              )}
            </div>
            <div
              className="filter-options-container"
              style={{
                maxHeight: "550px", // Set a maximum height for the container
                overflowY: "auto", // Enable vertical scrolling
                paddingRight: "10px", // Add padding for better UX
              }}
            >
              {/* {headers
                .filter((_, index) => index === 0 || index >= 3)
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0 ? 0 : filteredIndex + 2;

                  const uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ]; */}
              {headers
                .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0
                      ? 0
                      : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0); // Adjust for skipped indexes 2 and 4

                  let uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];

                  // Sort index 0 and index 6 in ascending order
                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }
                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption, // Update the filters state
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""} // Show selected filter if present
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const HODv2Dashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const reviewType = "hod";
  const reviewLevel = 1;
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(String(questionText)); // Ensure the input is a string
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const fetchDashboardData = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();
      const { data, status, message } = result;

      if (status !== 200) {
        throw new Error(message || "Failed to fetch dashboard data");
      }

      // Extract headers and rows from the `table_data`
      const rawTableData = data?.table_data || [];
      const rawHeaders = rawTableData[0] || [];
      const rawRows = rawTableData.slice(1) || [];

      // Format headers by removing prefixes
      const formattedHeaders = rawHeaders.map((header) =>
        header.replace(/^t\*|d\*|n\*/, "")
      );

      // Format rows: Handle dates and other formatting as needed
      const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        });
      };

      const transformedRows = rawRows.map((row) =>
        row.map((cell, index) => {
          if (rawHeaders[index]?.startsWith("d*")) {
            return formatDate(cell);
          }
          return cell;
        })
      );

      // Update state with headers and transformed rows
      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleCancel = () => {
    window.location.reload(); // This will refresh the page
  };
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        className=""
        style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
      >
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Head of Department Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleCancel} // Add onClick handler
            >
              CANCEL
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                width: "160px",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={() => {
                if (selectedRows.length > 0) {
                  const queryString = selectedRows.join(","); // Join selected IDs with commas
                  navigate(`/hod_review?MNTQuestionNumbers=${queryString}`); // Pass IDs in the query string
                }
              }}
            >
              REVIEW SELECTED
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter Questions. Export a list of question or search
          for a question. When searching, enter at least two characters in the
          search field.
        </p>
        <div>
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
        </div>
      </div>
    </div>
  );
};

export default HODv2Dashboard;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import TablewithCheckbox from "../../../Components/TableComponent/TablewithCheckbox";

// const HODv2Dashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const navigate = useNavigate();

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//   const reviewType = "hod";
//   const reviewLevel = 1;
//   const accessToken = localStorage.getItem("other");

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//     // eslint-disable-next-line
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(String(questionText));
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             {/* If you want LaTeX rendering, keep Latex here */}
//             {segment}
//           </span>
//         );
//       }
//     });
//   };

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();
//       const { data, status, message } = result;

//       if (status !== 200) {
//         throw new Error(message || "Failed to fetch dashboard data");
//       }

//       // Extract headers and rows from the `table_data`
//       const rawTableData = data?.table_data || [];
//       const rawHeaders = rawTableData[0] || [];
//       const rawRows = rawTableData.slice(1) || [];

//       // Format headers by removing prefixes
//       const formattedHeaders = rawHeaders.map((header) =>
//         header.replace(/^t\*|d\*|n\*/, "")
//       );

//       // Format rows: Handle dates and other formatting as needed
//       const formatDate = (dateString) => {
//         if (!dateString) return null;
//         const date = new Date(dateString);
//         return date.toLocaleDateString("en-US", {
//           year: "numeric",
//           month: "short",
//           day: "2-digit",
//         });
//       };

//       const transformedRows = rawRows.map((row) =>
//         row.map((cell, index) => {
//           if (rawHeaders[index]?.startsWith("d*")) {
//             return formatDate(cell);
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   // Handler for "REVIEW SELECTED" button
//   const handleReviewSelected = () => {
//     if (selectedRows.length > 0) {
//       const queryString = selectedRows.join(",");
//       navigate(`/hod_review?MNTQuestionNumbers=${queryString}`);
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div
//         className=""
//         style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
//       >
//         <div className="create-role-container-ques-dashboards">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Head of Department Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 width: "160px",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={handleReviewSelected}
//               disabled={selectedRows.length === 0}
//             >
//               REVIEW SELECTED
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter Questions. Export a list of question or search
//           for a question. When searching, enter at least two characters in the
//           search field.
//         </p>
//         <div>
//           <TablewithCheckbox
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionText={renderQuestionText}
//             pageType="hod"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HODv2Dashboard;
